


























    import {
        Component,
        Prop,
        Vue,
	} from 'vue-property-decorator';
	import { internet } from '@/utils/Internet';
	import Util from '@/utils/Util';
	import { AxiosResponse } from 'axios';
	@Component({
		name: 'CumplioInstructivo',
		components: {},
	})
	export default class CumplioInstructivo extends Vue {
        public title = this.$t("ResultEvalText.llmTitle");
        public cumplimientoLLM = '';
        public isLoading = false;
        public transcripcion = '';
        public transcrito = false;
        public diarizacion = [
            {hablante: '0', frase: 'Hola'},
            {hablante: '1', frase: 'Que tal'},
            {hablante: '0', frase: 'Como estas?'},
        ];
        public diarizado = false;
        public mostrar = false;
        @Prop({
            type: String,
            required: true,
        })
        readonly audio!: string;

        mounted() {
            console.log("CUMPLIMIENTO INSTRUCTIVO LLM", this.audio);
            this.getData();
        }

        public getData() {
            this.isLoading = true;
            const request_evAudio = internet
                .newRequest()
                .get(
                    `getEvaluacionCualitativaAudio?AudioNombre=${this.audio}`
                );
            Util.waitForPromises([
                request_evAudio,
            ])
                .then((responses) => {
                    console.log(responses[0] as AxiosResponse);
                    let respuesta = responses[0].data;
                    console.log("RESPUESTA: ", respuesta);
                    this.cumplimientoLLM = respuesta.CumplioInstructivo;
                    this.transcrito = respuesta.Transcrito;
                    this.transcripcion = respuesta.Transcripcion;
                    this.diarizado = respuesta.Diarizado;
                    this.diarizacion = respuesta.Diarizacion;
                })
                .catch(console.log)
                .finally(() => {
                    this.isLoading = false;
                });
        }
    }
